export default __webpack_public_path__ + "locales/ru/EmbeddingPanel.json?hash=086aacf7094f6c5ebd0c102f114e3d8f";